import { ModelBase, NeoModel, Validation, Rules } from '@singularsystems/neo-core';

@NeoModel
export default class InviteUserCommand extends ModelBase {

   @Rules.Required()
   @Rules.EmailAddress()
   public inviteEmailAddress: string = "";

   public postRegisterRedirectURL: string = "";

   // Client Rules

   protected addBusinessRules(rules: Validation.Rules<this>) {
      super.addBusinessRules(rules);
   }
}